import * as ACTION_TYPES from '@actions/action_types'
import type { UseQueryOptions } from 'react-query'
import { useAppQuery } from '../services/useAppQuery'

export const get_reditus_widget_token = (reactQueryOptions: UseQueryOptions) => {
  return useAppQuery({
    key: ['reditus-widget-token'],
    url: ACTION_TYPES.REDITUS_WIDGET_TOKEN_PATH,
    reactQueryOptions,
  })
}
